import styled from "styled-components";
import Spinner from "assets/images/Spinner.gif";
const LoadingSpinner = ({ width }: { width: number }) => {
  return (
    <Loading>
      <img
        src={Spinner}
        alt="loading"
        style={{ width: width, height: width }}
      />
    </Loading>
  );
};

export default LoadingSpinner;

const Loading = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
